import { getFixedT } from '@app/core/i18n';

import { ButtonsProps, WizardButtons } from '@app/common/components/configurable-wizards/wizard-buttons';
import { injectPropsAndMakeOptional } from '@app/common/utils/react/injectProps';

import { Constants } from './constants';

// eslint-disable-next-line i18next/no-literal-string
const t = getFixedT(null, Constants.I18N_NS);

/**
 * Retrieval buttons component with injected localization props.
 * We are still able to redefine it locally for specific steps if needed.
 */
// eslint-disable-next-line max-len
export const RetrievalWizardButtons = injectPropsAndMakeOptional<ButtonsProps, 'backTitle' | 'cancelTitle'>(
  WizardButtons,
  {
    backTitle: t('user-retrieval.wizard.buttons.back.title|Wizard\'s back button text', 'Back'),
    cancelTitle: t('user-retrieval.wizard.buttons.cancel.title|Wizard\'s cancel button text', 'Return to login'),
  },
);
